import { Search } from 'lucide-react';

const base = `w-full p-4 border rounded-xl text-base text-gray-900 bg-white placeholder:text-gray-400 focus:outline-none focus:border-primary focus:ring-2 focus:ring-primary/10 transition-all duration-200 disabled:bg-gray-50 disabled:cursor-not-allowed`;

const Input = ({ label, error, type = 'text', placeholder, disabled = false, className = '', inputClassName = '', id, ...props }) => {
  const inputId = id || label?.toLowerCase().replace(/\s+/g, '-');
  return (
    <div className={`space-y-2 ${className}`}>
      {label && <label htmlFor={inputId} className="block text-sm font-medium text-gray-700">{label}</label>}
      <input id={inputId} type={type} placeholder={placeholder} disabled={disabled}
        className={`${base} ${error ? 'border-red-300 bg-red-50' : 'border-gray-200'} ${inputClassName}`} {...props} />
      {error && <p className="text-sm text-red-500">{error}</p>}
    </div>
  );
};

Input.Search = ({ placeholder = 'Search...', className = '', inputClassName = '', ...props }) => (
  <div className={`relative ${className}`}>
    <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
    <input type="text" placeholder={placeholder}
      className={`w-full pl-12 pr-4 py-3 bg-gray-50 border border-transparent rounded-full placeholder:text-gray-400 focus:bg-white focus:border-gray-200 focus:outline-none transition-all duration-200 ${inputClassName}`}
      {...props} />
  </div>
);

Input.Select = ({ label, error, options = [], placeholder = 'Select an option', disabled = false, className = '', selectClassName = '', id, ...props }) => {
  const selectId = id || label?.toLowerCase().replace(/\s+/g, '-');
  return (
    <div className={`space-y-2 ${className}`}>
      {label && <label htmlFor={selectId} className="block text-sm font-medium text-gray-700">{label}</label>}
      <select id={selectId} disabled={disabled} className={`${base} ${error ? 'border-red-300 bg-red-50' : 'border-gray-200'} ${selectClassName}`} {...props}>
        <option value="">{placeholder}</option>
        {options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
      {error && <p className="text-sm text-red-500">{error}</p>}
    </div>
  );
};

export default Input;
